// src/components/icons/FilterAltIcon.js
/* ------------------------------------------------------------------ */
/* FilterAltIcon – filter icon used to open filter options                    */
/* ------------------------------------------------------------------ */
/**
 * @param {object} props  Regular SVG props (className, onClick, …)
 * @returns {JSX.Element}
 */
export const FilterAltIcon = ({
  className = "h-8 w-8 fill-current",
  ...props
}) => (
  <svg className={className} viewBox="0 -960 960 960" {...props}>
    <path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160zm40-308 198-252H282zm0 0"></path>
  </svg>
);
